import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['typeInput', 'whenIndividual', 'whenCorporate']
  connect() {
    this.toggleFields();
  }

  onChangePersonType() {
   this.toggleFields();
  }

  toggleFields() {
    this.whenIndividualTargets.forEach(($el) => $el.classList.toggle(('d-block'), this.typeInputTarget.value === 'individual'))
    this.whenCorporateTargets.forEach(($el) => $el.classList.toggle(('d-block'), this.typeInputTarget.value === 'corporate'))
  }

};